var _path, _path2, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m91.99 46.025 2-.042a2 2 0 0 0-1.38-1.859l-.62 1.901ZM59.275 3.695l2 .034A2 2 0 0 0 59.82 1.77l-.545 1.925Zm4.037 12.328 1.839.787a2 2 0 0 0-.248-2l-1.59 1.213Zm18.54 22.422L83.5 37.31a2 2 0 0 0-2.071-.818l.425 1.954Zm8.138 7.623c.007.31.01.62.01.932h4c0-.34-.004-.679-.01-1.017l-4 .085ZM90 47c0 23.748-19.252 43-43 43v4c25.957 0 47-21.043 47-47h-4ZM47 90C23.252 90 4 70.748 4 47H0c0 25.957 21.043 47 47 47v-4ZM4 47C4 23.252 23.252 4 47 4V0C21.043 0 0 21.043 0 47h4ZM47 4c4.07 0 8.004.565 11.73 1.62l1.09-3.85A47.033 47.033 0 0 0 47 0v4Zm10.276-.34c-.003.128-.004.256-.004.385h4l.003-.316-4-.07Zm-.004.385c0 4.956 1.659 9.53 4.45 13.191l3.18-2.425a17.686 17.686 0 0 1-3.63-10.766h-4Zm4.201 11.192A18.31 18.31 0 0 0 60 22.454h4c0-2.007.41-3.914 1.15-5.644l-3.677-1.573ZM60 22.454c0 10.142 8.222 18.364 18.364 18.364v-4C70.43 36.818 64 30.388 64 22.455h-4Zm18.364 18.364c1.34 0 2.65-.144 3.913-.418l-.849-3.91c-.986.215-2.01.328-3.064.328v4Zm1.843-1.236a21.82 21.82 0 0 0 11.161 8.344l1.243-3.802a17.82 17.82 0 0 1-9.112-6.815l-3.292 2.273Z",
    fill: "#BF4D28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.137 8.648a12.252 12.252 0 0 1 4.772 9.715c0 6.779-5.494 12.273-12.272 12.273-3.485 0-6.63-1.452-8.864-3.784M34.046 89.79a11.57 11.57 0 0 1-.682-3.927c0-6.401 5.19-11.59 11.59-11.59 6.402 0 11.592 5.189 11.592 11.59a11.55 11.55 0 0 1-1.025 4.773",
    stroke: "#BF4D28",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 45.636,
    r: 9.545,
    stroke: "#BF4D28",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.727,
    cy: 19.727,
    r: 5.455,
    fill: "#BF4D28"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.454,
    cy: 55.182,
    r: 5.455,
    fill: "#BF4D28"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.182,
    cy: 60.636,
    r: 5.455,
    fill: "#BF4D28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieIcon);
export default __webpack_public_path__ + "static/media/cookie-icon.284c13cd95f88001c047830f5e0ef262.svg";
export { ForwardRef as ReactComponent };